module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2VcFAPVkMWwHTk1qTopdmH-ab8d4fe38534197a60c579321bef288e.jpg";